module.exports = __webpack_public_path__ + "img/ifpi-start-hero-desktop.2b4cd691.jpg";